import Box from '@mui/material/Box';
import React from 'react';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions';
import TextBtnSection from '../components/Section/TextBtnSection';
import SmallCards from '../components/Cards/SmallCards';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';

export default function RfCollagenInduction() {
const { t } = useTranslation();
   

      const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description:  t('rf_collagen_induction.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description:  t('rf_collagen_induction.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description:  t('rf_collagen_induction.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description:  t('rf_collagen_induction.sessions'),
        }
    ];

    const accodirons = [
        {
            title: t('what'),
            content: t('rf_collagen_induction.what')
        },
        {
            title: t('how'),
            content: t('rf_collagen_induction.how')
        },
        {
            title: t('benefits'),
            content: t('rf_collagen_induction.benefits')
        },
        {
            title: t('zone'),
            content: t('rf_collagen_induction.zone')
        },
        {
            title: t('pairs'),
            content: t('rf_collagen_induction.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('rf_collagen_induction.expected_results')
        },
        {
            title: t('results'),
            content: t('rf_collagen_induction.results')
        },
    ]

    const TextBtnSectionData = {
        type: t('skinTherapies'),
        title: t('rf_collagen_induction.mainTitle'),
        description: t('rf_collagen_induction.mainDesc'),
        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION™ Fractional Microneedling RF")}`,
        price: `${t('price_session')} €350`,
        doctorIncluded: true
    };

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/rf.png`} width={1} height={1} sx={{ objectFit: 'cover' }} />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection data={TextBtnSectionData} titleSize={{ md: 5.9, xs: 12 }} descriptionSize={{ md: 9, xs: 12 }} />
            </Box>

            <Box marginTop={{ md: '107px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Box sx={{ height: { md: 500, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION™ Fractional Microneedling RF")}`,
                            type: t('rf_collagen_induction.tech'),
                            // learn: '/',
                            title: t('rf_collagen_induction.techTitle'),
                            size: { md: 6.5, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageSize: {md: 5.5, xs: 12},
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/ALMA.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('rf_collagen_induction.techDesc')
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '80px', xs: '50px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
        </Box>
    )
}